import { translate } from 'i18n/i18n'
import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'
import { MAP_VISUAL } from 'stores/mapControlsStore/types'
import { smallStore } from 'stores/smallStore/smallStore'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import { DefaultHeatmapRow } from '../DefaultHeatmapRow/DefaultHeatmapRow'

export const IrrigationActivityPressureHeatmapRow = () => {
  const appliedIrrigationActivityDisplay = smallStore.useSelector((s) => s.appliedIrrigationActivityDisplay)

  const pointValueType = mapControlsStore.useSelector(
    (s) => s.mapVisualValueGroup?.[MAP_VISUAL.POINT]?.irrigation_activity_pressure?.valueType,
  )

  // to get refreshes on unit changes working well
  const { rain } = userDetailsStore.useSelector((s) => ({
    rain: s.rain,
    volume: s.volume,
    flowRate: s.flowRate,
  }))

  let suffix = translate.phrases.banyanApp('Hours')

  if (appliedIrrigationActivityDisplay === 'VOLUME')
    suffix = unitConverter.precipitation(null, { outputUnit: rain === 'IMPERIAL' ? 'in' : 'mm' }).suffix()

  if (pointValueType?.endsWith('_status')) return null

  return <DefaultHeatmapRow suffix={suffix} />
}
